module.exports = __webpack_public_path__ + "static/media/vehicle-lights-reversing.d5e3b7e6.mp4";